<template>
  <transition name="modal-fade">
    <div
      v-if="isVisible"
      class="fixed inset-0 z-50 flex items-center justify-center p-4"
      @click.self="handleCancel"
    >
      <div class="absolute inset-0 bg-black bg-opacity-50"></div>

      <div
        class="relative bg-white rounded-[16px] shadow-2xl max-w-md w-full p-6 transform transition-all"
      >
        <div class="flex justify-center mb-4">
          <div class="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 6H6C4.89543 6 4 6.89543 4 8V18C4 19.1046 4.89543 20 6 20H16C17.1046 20 18 19.1046 18 18V14M14 4H20M20 4V10M20 4L10 14"
                stroke="#3B82F6"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>

        <h3 class="text-[18px] font-semibold text-bodyText text-center mb-2">
          Opening External Link
        </h3>

        <p class="text-[14px] text-gray-600 text-center mb-6">
          You are about to leave EdgeSpace and visit an external website. Do you want to continue?
        </p>

        <div
          v-if="showUrl && url"
          class="mb-6 p-3 bg-gray-50 rounded-[8px] border border-gray-200"
        >
          <p class="text-[11px] text-gray-500 mb-1 font-medium">Destination:</p>
          <p class="text-[12px] text-gray-700 truncate">{{ url }}</p>
        </div>

        <div class="flex gap-3">
          <button
            @click="handleCancel"
            class="flex-1 px-4 py-2.5 border border-gray-300 text-bodyText rounded-[8px] hover:bg-gray-50 transition-colors font-medium text-[14px]"
          >
            Cancel
          </button>
          <button
            @click="handleContinue"
            class="flex-1 px-4 py-2.5 bg-black text-white rounded-[8px] hover:bg-gray-800 transition-colors font-medium text-[14px]"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ExternalLinkModal",
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    url: {
      type: String,
      default: "",
    },
    showUrl: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleCancel() {
      this.$emit("cancel");
    },
    handleContinue() {
      this.$emit("continue");
    },
  },
};
</script>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active .relative,
.modal-fade-leave-active .relative {
  transition: transform 0.2s ease;
}

.modal-fade-enter-from .relative {
  transform: scale(0.95);
}

.modal-fade-leave-to .relative {
  transform: scale(0.95);
}
</style>
